import axios from 'axios';
import config from 'config';
import backendConfig from '../utils/backendConfig';

function fetchAll() {
  return backendConfig.get().then(({backendUrl}) => {
    let url = `${backendUrl}${config.backend.feeds.languages}`;
    return axios.get(url).then(resp => {
      const languages = resp.data || [];
      return languages;
    }).catch((error) => {
      const resp = error.response;
      resp.body = resp.data;
    });
  });
}

export default {
  fetchAll,
};



// WEBPACK FOOTER //
// ./src/models/languages.js